import React from 'react';
import AnnexeCarnetFormsPageShell from '../../components/AnnexeCarnetFormsPageShell';
import FormulaireStatic from './FormulaireStatic';

export default function Formulaire() {
  return (
    <AnnexeCarnetFormsPageShell
      strapiApiId="annexe-carnet-forms"
      defaultSectionLabel="Annexes"
      defaultTitle="Formulaires"
      defaultDeroulementTitle="Carnet d'adresses"
      StaticFallback={FormulaireStatic}
    />
  );
}
